import React, { useEffect, useState } from 'react';
import moment from "moment";
// import { Grid } from '@intech/web-ui';

import { FichaFinanceiraAssistidoEntidade } from '../../../../entidades';
import { FichaFinanceiraAssistidoService } from '../../../../services';
import { UltimaFolhaItem } from './UltimaFolhaItem';
import { LoadingComponent } from '../../../../components/LoadingComponent';
import { FolhaTitle, BoxFolha, FolhaHeader, HeaderProvDesc, HeaderInfo, HeaderValor } from './styles';
import { Alert } from '@intech/web-ui';

// import { Container } from './styles';

export const UltimaFolha: React.FC<any> = ({ plano, processoBeneficio }) => {
  const [dadosUltimaFolha, setDadosUltimaFolha] = useState<any>(null);
  const [erro, setErro] = useState('');

  useEffect(() => {
    (async () => {
      try {
        if (processoBeneficio) {
          if (processoBeneficio.CD_ESPECIE !== undefined) {
            var ultimaFolha = await FichaFinanceiraAssistidoService.BuscarUltimaPorPlanoProcesso(plano.CD_PLANO, processoBeneficio.CD_ESPECIE, processoBeneficio.ANO_PROCESSO, processoBeneficio.NUM_PROCESSO);
            setDadosUltimaFolha(ultimaFolha);
          }
        }
      } catch (err) {
        setErro(err.response ? err.response.data : err);
      }
    })();
  }, [plano, processoBeneficio]);

  if (processoBeneficio.CD_ESPECIE === null || processoBeneficio.CD_ESPECIE === undefined) {
    return (
      <Alert type={"info"}>
        {"Nenhum Processo de Benefício encontrado para este plano."}
      </Alert>
    );
  }

  if (dadosUltimaFolha !== null) {
    const Proventos = dadosUltimaFolha.Proventos.map((rubrica: FichaFinanceiraAssistidoEntidade, index: number) => {
      return <UltimaFolhaItem key={index} provento={true} rubrica={rubrica} />;
    });

    const Descontos = dadosUltimaFolha.Descontos.map((rubrica: FichaFinanceiraAssistidoEntidade, index: number) => {
      return (
        <UltimaFolhaItem key={index} provento={false} rubrica={rubrica} />
      );
    });

    return (
      <BoxFolha title={"Última Folha"} badgeText={`Referência ${moment(dadosUltimaFolha.Resumo.Referencia, "dd/MM/yyyy").format("MM/yyyy")}`}>

        {/* <FolhaTitle>Valor Líquido: <StaticField value={dadosUltimaFolha.Resumo.Liquido} type={"money"} /></FolhaTitle> */}
        <FolhaTitle>Valor Líquido: {`R$ ${dadosUltimaFolha.Resumo.Liquido.toLocaleString('pt-br', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`}</FolhaTitle>

        <FolhaHeader>

          <HeaderProvDesc>
            {"Tipo"}
          </HeaderProvDesc>

          <HeaderInfo>
            {"Rubrica (Competência)"}
          </HeaderInfo>

          <HeaderValor>
            {"Valor"}
          </HeaderValor>

        </FolhaHeader>

        <div>
          {Proventos}
          {Descontos}
        </div>
      </BoxFolha>
    );
  }

  return <LoadingComponent />;
}
